// Cart Upsell Handler - Smooth & Professional
(function() {
  if (window.cartUpsellHandlerActive) return;
  window.cartUpsellHandlerActive = true;

  document.addEventListener('click', function(event) {
    if (event.target.classList.contains('cart__upsell-add')) {
      event.preventDefault();
      event.stopPropagation();
      
      const button = event.target;
      const variantId = button.getAttribute('data-variant-id');
      const originalText = button.textContent;
      
      // Smooth button animation
      button.disabled = true;
      button.style.transition = 'all 0.3s ease';
      button.textContent = '...';
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        // Success animation
        button.textContent = '✓';
        button.style.transform = 'scale(1.1)';
        
        setTimeout(() => {
          button.style.transform = 'scale(1)';
        }, 150);
        
        return fetch('/cart.js');
      })
      .then(response => response.json())
      .then(cart => {
        // Update cart count with animation
        const cartBubbles = document.querySelectorAll('.cart-count-bubble, [data-cart-count]');
        cartBubbles.forEach(bubble => {
          if (bubble) {
            bubble.style.transition = 'transform 0.3s ease';
            bubble.style.transform = 'scale(1.2)';
            bubble.textContent = cart.item_count;
            setTimeout(() => {
              bubble.style.transform = 'scale(1)';
            }, 300);
          }
        });
        
        const isCartPage = window.location.pathname === '/cart';
        
        if (isCartPage) {
          // CART PAGE: Super smooth met loading overlay
          
          // Verberg de upsell button meteen (smooth fade)
          const upsellItem = button.closest('.cart__upsell-item');
          if (upsellItem) {
            upsellItem.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
            upsellItem.style.opacity = '0';
            upsellItem.style.transform = 'scale(0.95)';
          }
          
          // Toon mini success bericht
          button.textContent = '✓ Toegevoegd';
          button.style.backgroundColor = '#22c55e';
          button.style.color = 'white';
          
          // Smooth reload met korte delay zodat je de animatie ziet
          setTimeout(() => {
            // Fade hele pagina
            document.body.style.transition = 'opacity 0.3s ease';
            document.body.style.opacity = '0.7';
            
            setTimeout(() => {
              window.location.href = '/cart?updated=' + Date.now();
            }, 200);
          }, 600);
          
        } else {
          // CART DRAWER: Smooth HTML update
          return fetch(window.location.href)
            .then(response => response.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              
              // Fade out current content
              const currentCartItems = document.querySelector('.cart-drawer__items');
              const currentSummary = document.querySelector('.cart-drawer__summary');
              
              if (currentCartItems) {
                currentCartItems.style.transition = 'opacity 0.2s ease';
                currentCartItems.style.opacity = '0.5';
              }
              
              setTimeout(() => {
                // Update drawer items
                const newCartItems = doc.querySelector('.cart-drawer__items');
                if (newCartItems && currentCartItems) {
                  currentCartItems.innerHTML = newCartItems.innerHTML;
                  currentCartItems.style.opacity = '1';
                }
                
                // Update drawer summary
                const newSummary = doc.querySelector('.cart-drawer__summary');
                if (newSummary && currentSummary) {
                  currentSummary.innerHTML = newSummary.innerHTML;
                }
              }, 200);
              
              setTimeout(() => {
                button.disabled = false;
                button.textContent = originalText;
              }, 500);
            });
        }
      })
      .catch(error => {
        console.error('Error:', error);
        button.disabled = false;
        button.textContent = '✗';
        button.style.transform = 'scale(1)';
        setTimeout(() => {
          button.textContent = originalText;
        }, 1500);
      });
    }
  });
})();


